import { useGetGlobalSearchResultsPresenter } from './useGetGlobalSearchResultsPresenter'
import { GlobalSearchModal } from '../../views/GlobalSearchModal/GlobalSearchModal'

interface IGetGlobalSearchResultsPresenterProps {
  isOpen: boolean
  onClose: () => void
}

export const GetGlobalSearchResultsPresenter = ({
  isOpen,
  onClose,
}: IGetGlobalSearchResultsPresenterProps) => {
  const {
    commands: {
      changeQuery,
      submitQuery,
      openRecentItem,
      openResultItem,
      selectTab,
    },
    data: { query, recentItems, resultItems, tabs, inputRef },
    states: { showEnterHint, contentState, selectedTab, showTruncatedNotice },
  } = useGetGlobalSearchResultsPresenter(onClose)

  return (
    <GlobalSearchModal
      isOpen={isOpen}
      query={query}
      showEnterHint={showEnterHint}
      contentState={contentState}
      recentItems={recentItems}
      resultItems={resultItems}
      tabs={tabs}
      selectedTab={selectedTab}
      showTruncatedNotice={showTruncatedNotice}
      inputRef={inputRef}
      onClose={onClose}
      onQueryChange={changeQuery}
      onSubmit={submitQuery}
      onRecentItemClick={openRecentItem}
      onResultItemClick={openResultItem}
      onTabChange={selectTab}
    />
  )
}
